import { twMerge } from "tailwind-merge";

export function Heading3({
  children,
  elementType,
  className,
  id,
}: {
  children: React.ReactNode;
  elementType: "h1" | "h2" | "h3" | "h4";
  className?: string;
  id?: string;
}) {
  const Element = elementType;

  return (
    <Element
      id={id}
      className={twMerge(
        "text-2xl font-semibold tracking-tight text-gray-900",
        className
      )}
    >
      {children}
    </Element>
  );
}
